module.exports = __webpack_public_path__ + "static/media/notFoundAnyGif.7a194113.png";